"use client"

import { motion } from "framer-motion"
import { useState, useEffect } from "react"

interface CodeAnimationProps {
  code: string
  isVisible: boolean
}

export function CodeAnimation({ code, isVisible }: CodeAnimationProps) {
  const [displayedCode, setDisplayedCode] = useState("")
  const [showCursor, setShowCursor] = useState(true)

  useEffect(() => {
    if (!isVisible) {
      setDisplayedCode("")
      return
    }

    let currentIndex = 0
    const interval = setInterval(() => {
      if (currentIndex < code.length) {
        setDisplayedCode(code.slice(0, currentIndex + 1))
        currentIndex++
      } else {
        clearInterval(interval)
      }
    }, 25) // Her karakter 25ms'de yazılsın

    return () => clearInterval(interval)
  }, [code, isVisible])

  useEffect(() => {
    if (!isVisible) return
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev)
    }, 500)

    return () => clearInterval(cursorInterval)
  }, [isVisible])

  if (!isVisible) return null

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className="font-mono text-xs text-slate-700 bg-slate-50 px-3 py-2.5 rounded-md border border-slate-200 overflow-hidden w-full"
    >
      <span className="text-[rgb(3,74,166)] font-semibold">$</span>{" "}
      <span className="text-slate-800">{displayedCode}</span>
      {showCursor && (
        <span className="inline-block w-0.5 h-3.5 bg-[rgb(3,74,166)] ml-0.5 animate-pulse" />
      )}
    </motion.div>
  )
}

